"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTranslator = void 0;
exports.authTranslator = {
    en: {
        username: "Username",
        email: "Email",
        pass: "Password",
        confirmPass: "Confirm Password",
        loginFormTitle: "LOGIN",
        regFormTitle: "REGISTER",
        loginMessages: {
            emptyEmail: "email cant be blank",
        },
        regMessages: {
            passwordMismatch: "passwords do not match!",
            emptyFields: "all fields are required",
            weakPassword: "your password is too weak",
        },
    },
    ru: {
        username: "Имя",
        email: "Email",
        pass: "Пароль",
        confirmPass: "Подтвердить пароль",
        loginFormTitle: "ЛОГИН",
        regFormTitle: "РЕГИСТРАЦИЯ",
        loginMessages: {
            emptyEmail: "email поле не заполнено",
        },
        regMessages: {
            passwordMismatch: "пароли не совпадают",
            emptyFields: "не все поля заполнены",
            weakPassword: "пароль слишком слабый",
        },
    },
};
